import {
    CASHLIFTAPPROVEREJECTPARTNER_SUCCESS,
    CASHLIFTAPPROVEREJECTPARTNER_FAILED,
    RESET_CASHLIFTAPPROVEREJECTPARTNER,
    LOADING_CASHLIFTAPPROVEREJECTPARTNER,
    NETWORK_ERROR_CASHLIFTAPPROVEREJECTPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_CASHLIFTAPPROVEREJECTPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case CASHLIFTAPPROVEREJECTPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case CASHLIFTAPPROVEREJECTPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_CASHLIFTAPPROVEREJECTPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_CASHLIFTAPPROVEREJECTPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};